import React from 'react';
import { useLocationsQuery } from '../../hooks/useQueries.ts';

interface LocationSelectorProps {
  value: number | null;
  onChange: (id: number | null) => void;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({ value, onChange }) => {
  const { data: locations } = useLocationsQuery();

  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      className="purchase-controls__location-select"
    >
      <option value="">Select location...</option>
      {locations?.map((location) => (
        <option key={location.id} value={location.id}>
          {location.name}
        </option>
      ))}
    </select>
  );
};

export default LocationSelector;
